import React from 'react';
import PropTypes from 'prop-types';
import ChartKendaraya from 'components/LH/HC/Chart';

const HCCharts = ({ horoscopeDataM, horoscopeDataF }) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '0px' }}>
            <div style={{ width: 400, height: 400 }}>
                <ChartKendaraya
                    devision="D1"
                    lagna={horoscopeDataM.lagna}
                    rashiId={null}
                    lagnaSputaya={horoscopeDataM.lagnaSputaya}
                    planets={horoscopeDataM.planet}
                    gender="M"
                />
            </div>
            <div style={{ width: 400, height: 400 }}>
                <ChartKendaraya
                    devision="D1"
                    lagna={horoscopeDataF.navamsaka}
                    rashiId={null}
                    lagnaSputaya={horoscopeDataF.navamsakaSputaya}
                    planets={horoscopeDataF.planet}
                    gender="F"
                />
            </div>
        </div>
    );
};
HCCharts.propTypes = {
    horoscopeDataM: PropTypes.shape({
        lagna: PropTypes.any,
        lagnaId: PropTypes.any,
        lagnaSputaya: PropTypes.any,
        navamsaka: PropTypes.any,
        navamsakaId: PropTypes.any,
        navamsakaSputaya: PropTypes.any,
        planet: PropTypes.any,
    }).isRequired,
    horoscopeDataF: PropTypes.shape({
        lagna: PropTypes.any,
        lagnaId: PropTypes.any,
        lagnaSputaya: PropTypes.any,
        navamsaka: PropTypes.any,
        navamsakaId: PropTypes.any,
        navamsakaSputaya: PropTypes.any,
        planet: PropTypes.any,
    }).isRequired,
};
export default HCCharts;
